export default "__VITE_ASSET__BeTLio2w__"